import React from 'react';
import PropTypes from 'prop-types';

import Copy from '../Copy';

import { STATUS_CONFIRMED, numberToString } from '../../commons/utils';

const InfoHeader = (props) => {
  const {
    locator,
    identifier,
    status,
    modified,
    valorated
  } = props;

  const showConfirmedInfo = (status === STATUS_CONFIRMED);
  const statusMessage = (valorated) ? 'sinConfirmar' : 'sinValorar';

  return (
    <>
      {showConfirmedInfo
        ? (
          <>
            <span className="confirmed-text">
              <span className="icon-check" />
              <Copy of="localizador" />
            </span>
            {locator}
            {(modified) &&
              <span className="no-confirmed-text">
                <Copy of={statusMessage} />
              </span>
            }
          </>
        )
        : (
          <>
            <Copy of="reserva" />
            {` ${numberToString(identifier)}`}
            <span className="no-confirmed-text">
              <Copy of={statusMessage} />
            </span>
          </>
        )
      }
    </>
  );
};

InfoHeader.propTypes = {
  locator: PropTypes.string,
  identifier: PropTypes.number,
  status: PropTypes.string,
  modified: PropTypes.bool,
  valorated: PropTypes.bool
};

InfoHeader.defaultProps = {
  locator: '',
  identifier: 0,
  status: '',
  modified: false,
  valorated: true
};

export default InfoHeader;
